import { useQuery } from '@apollo/react-hooks'

import {
  FundingSourceAccount,
  FundingSourceType,
  RecurrenceRuleInput,
  SpendAccount,
} from 'generated/types'

import transferInfoQuery from './gql/transfer-info-query.gql'

type TransferInfoQuery = {
  spendAccount: SpendAccount
  fundingSourceAccounts: FundingSourceAccount[]
}

type TransferInfoQueryVariables = {
  recurrenceRule: RecurrenceRuleInput
}

export const useTransferAccounts = () => {
  const { data, loading, error } = useQuery<TransferInfoQuery, TransferInfoQueryVariables>(
    transferInfoQuery,
  )

  const checkingAccountId = data?.spendAccount.accountId
  const externalFundingSource = data?.fundingSourceAccounts.find(
    account => account.fundType === FundingSourceType.Ach,
  )
  const externalFundingSourceId = externalFundingSource ? externalFundingSource.id.toString() : ''

  return { checkingAccountId, externalFundingSourceId, loading, error }
}
